
import React, { useEffect, useState } from "react";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { useDispatch } from "react-redux";
import { useAuthState } from "../../../Helper/Context/context";

export default function ViewAttachment(props) {
    const { handleViewAttachModal, GridData } = props

     const userDetails = useAuthState();
       const { UserID, token } = userDetails
       const dispatch = useDispatch();

    const url = sessionStorage.getItem('Url')

    return (
        <>
            <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "#00000055" }}
            >
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content p-4" style={{height:"90vh"}}>
                        <div className="modal-header pt-0">
                            <h5 className="modal-title fw-bold text-danger modal-title-fs ml-4" id="exampleModalLongTitle">
                                Photo
                            </h5>
                            <button onClick={() => handleViewAttachModal()} type="button" className="close border_cancel_btn" style={{ marginLeft: "auto" }}>
								<span aria-hidden="true" className=" py-0" style={{ color: "red" }}>&times;</span>
							</button>
                           
                        </div>                      
                       <div className="modal-body" style={{ display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden",height:"-500px" }}>
                        {url ? (
                            <div style={{cursor:"zoom-in", maxWidth: "280px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <ReactPanZoom
                                    image={url}
                                    alt='View attachment'
                                    scale={-10} 
                                    style={{ width: "100%", height: "auto" }} 
                                />
                            </div>
                        ) : (
                            <div>No image available</div>
                        )}
                    </div>
                    </div>
                </div>


            </div>
        </>
    );
}
